import { render, staticRenderFns } from "./CampaignAccount.vue?vue&type=template&id=b8d28618"
import script from "./CampaignAccount.vue?vue&type=script&lang=js"
export * from "./CampaignAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports